import axios from "axios";
import { centralizedHost } from "~/Utils";
import { decodeHTML } from "~/Utils/CommonUtils";
import { ModuleFields } from "~/Utils/drilldownData";

export interface OptionType {
  label: string;
  value: string;
}
export type AsyncSelectField = ModuleFields & {
  loadOptions?: () => Promise<OptionType[]>;
};

export const fetchDataAndTransform = async (
  url: string,
  labelKey: string,
  valueKey?: string,
  filterFn?: (item: any) => boolean
): Promise<OptionType[]> => {
  try {
    const res = await axios.get(`${centralizedHost}${url}`);
    if (res?.data) {
      const filteredData = filterFn ? res.data.filter(filterFn) : res.data;
      return filteredData.map((item: any) => ({
        label: decodeHTML(item[labelKey]),
        value: valueKey ? decodeHTML(item[valueKey]) : decodeHTML(item[labelKey]),
      }));
    }
    return [];
  } catch (err) {
    console.error("Error fetching data:", err);
    return [];
  }
};

export const fetchDataAndTransformPrivacyPromo = async (
  url: string,
  labelKey: string,
  valueKey?: string,
  filterFn?: (item: any) => boolean
): Promise<OptionType[]> => {
  try {
    const res = await axios.get(`${centralizedHost}${url}`);
    if (res?.data) {
      const filteredData = filterFn ? res.data.filter(filterFn) : res.data;
      return filteredData.map((item: any) => ({
        label: decodeHTML(item[labelKey]),
        value: valueKey ? decodeHTML(item[valueKey]) : decodeHTML(item[labelKey]),
        slug: item.slug, // ✅ ADD THIS
      }));
    }
    return [];
  } catch (err) {
    console.error("Error fetching data:", err);
    return [];
  }
};

export const fetchMouleSelection = () => fetchDataAndTransform("/api/project-airport-drop-down", "name", "id");

export const fetchMouleSelectionMyairports = () =>
  fetchDataAndTransformPrivacyPromo("/api/project-airport-drop-down", "name", "id", (item) => {
    const slug = item.slug?.toLowerCase();
    const allowedPrefixes = ["myairport", "eraman", "passenger"];
    return allowedPrefixes.some((prefix) => slug?.startsWith(prefix));
  });

export const fetchMouleSelectionFaqQandA = () =>
  fetchDataAndTransformPrivacyPromo("/api/project-airport-drop-down", "name", "id", (item) => {
    const slug = item.slug?.toLowerCase();
    const allowedPrefixes = ["myairport", "eraman", "magp"];
    return allowedPrefixes.some((prefix) => slug?.startsWith(prefix));
  });

export const fetchMouleSelectionPromotion = () =>
  fetchDataAndTransformPrivacyPromo("/api/project-airport-drop-down", "name", "id", (item) => {
    const slug = item.slug?.toLowerCase();
    const allowedPrefixes = ["passenger", "eraman"];
    return allowedPrefixes.some((prefix) => slug?.startsWith(prefix));
  });

export const fetchMouleSelectionShopDine = () =>
  fetchDataAndTransform("/api/project-airport-drop-down", "name", "id", (item) => {
    const slug = item.slug?.toLowerCase();
    const allowedPrefixes = ["passenger", "myairport"];
    return allowedPrefixes.some((prefix) => slug?.startsWith(prefix));
  });

export const fetchMouleSelectionBanner = () =>
  fetchDataAndTransform("/api/project-airport-drop-down", "name", "id", (item) => {
    const slug = item.slug?.toLowerCase();
    const allowedPrefixes = ["passenger", "eraman", "corporate", "magp"];
    return allowedPrefixes.some((prefix) => slug?.startsWith(prefix));
  });

export const fetchMouleSelectionPrivacy = () =>
  fetchDataAndTransformPrivacyPromo("/api/project-airport-drop-down", "name", "id", (item) => {
    const slug = item.slug?.toLowerCase();
    const allowedPrefixes = ["myairport", "corporate"];
    return allowedPrefixes.some((prefix) => slug?.startsWith(prefix));
  });
